"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = MathJaxHelper;

var _react = _interopRequireWildcard(require("react"));

require('mathjax/es5/mml-svg.js');

function MathJaxHelper(props) {
  var divRev = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    divRev.current.appendChild(window.MathJax.mathml2svg(props.math));
  }, [props.math]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    id: props.id || 'mathjax-container',
    style: props.style,
    className: props.className,
    ref: divRev
  });
}